import { defineStore } from 'pinia';
import axios from 'axios';

export const useDashboardStore = defineStore('dashboard', () => {
    const actions = {
        submit: (params) => axios.post('/api/v1/dashboard', params),
    };

    return {
        ...actions,
    };
});
